import React from 'react';
import times from 'lodash/times';
import { Box } from '../CommonComponents/OPL/Box/Box';
import { Shimmer } from '../CommonComponents/OPL/Shimmer/Shimmer';
import { TextLoading } from '../CommonComponents/OPL/Text/Text.loading';
import { Separator } from '../CommonComponents/OPL/Separator/Separator';
import { MarginProps } from '../theme/styledProps';
import { ModalBody } from '../CommonComponents/OPL/Modal/ModalBody';
import { ModalFooter } from '../CommonComponents/OPL/Modal/ModalFooter';

const LoadingToggle: React.FC<MarginProps> = props => {
  return (
    <Box display="flex" alignItems="center" justifyContent="space-between" my="16" {...props}>
      <TextLoading width={100} height="h6" />

      <Shimmer width={48} height={24} style={{ borderRadius: 12 }} />
    </Box>
  );
};

const LoadingSelect: React.FC<MarginProps> = props => {
  return (
    <Box display="flex" alignItems="center" justifyContent="space-between" my="16" {...props}>
      <TextLoading width={100} height="h6" />

      <Shimmer width={240} height={36} />
    </Box>
  );
};

export const ClientAccessLoading = () => {
  return (
    <>
      <ModalBody>
        <LoadingToggle />

        <LoadingSelect ml="24" />

        <Separator />

        <LoadingToggle />

        <TextLoading width={300} height="small" mt={-10} />

        {times(3).map(key => (
          <LoadingToggle key={key} ml="24" />
        ))}

        <Separator />

        <TextLoading width={50} height="h6" my="16" />

        {times(2).map(key => (
          <LoadingToggle key={key} ml="24" />
        ))}

        <Separator />

        <LoadingSelect mb="0" />
      </ModalBody>

      <ModalFooter hasBorder>
        <Shimmer width={100} height={36} mr="8" />
        <Shimmer width={100} height={36} />
      </ModalFooter>
    </>
  );
};
